(function () {
  const product = document.querySelector('.wt-product');
  if (!product) return;

  let preference = 'subscription';
  let tries = 0;
  let timer = 0;

  function wantedInput() {
    const type = preference === 'one_time' ? 'one_time' : 'subscription';
    return product.querySelector('.sls-option[data-type="' + type + '"]');
  }

  function apply() {
    window.clearTimeout(timer);
    const input = wantedInput();
    if (!input || input.checked || tries > 10) return;
    tries += 1;
    input.click();
    timer = window.setTimeout(apply, 150);
  }

  product.addEventListener('change', function (event) {
    const input = event.target;
    if (!input || !input.classList || !input.classList.contains('sls-option')) return;
    preference = input.dataset.type === 'one_time' ? 'one_time' : 'subscription';
    tries = 0;
    window.clearTimeout(timer);
  });

  const observer = new MutationObserver(function (mutations) {
    for (let i = 0; i < mutations.length; i += 1) {
      const nodes = mutations[i].addedNodes;
      for (let j = 0; j < nodes.length; j += 1) {
        const node = nodes[j];
        if (node.nodeType !== 1) continue;
        if (node.matches('.sealsubs-container, .sls-option') || node.querySelector('.sls-option')) {
          tries = 0;
          apply();
          return;
        }
      }
    }
  });

  observer.observe(product, { childList: true, subtree: true });
  apply();
})();
